import { HTTP } from "./http";

let API_SERVER = "";
if (window.location.href.indexOf("8080") > -1) {
  API_SERVER = "http://www.localhost:8888/back-end-endpoint-season-rollover.php";
} else {
  API_SERVER = "/personal-training-BE/back-end-endpoint-season-rollover.php";
}

/**
 * Thin axios wrapper for the season-rollover endpoint. Same shape as the
 * other services in this folder — one `find()` that POSTs `{action, ...}`
 * to the dispatcher.
 */
const SeasonRollover = {
  find(params) {
    return HTTP.post(API_SERVER, params);
  },
};

export { SeasonRollover };
